// frontend/src/components/payment/PaymentPageSkeleton.js
//
// The /payment/success and /payment/failure chunk fallback: the pages' own
// card, drawn in skeleton parts (PaymentSkeletonParts.js), inside the one
// accessible, motion-aware skeleton shell (SkeletonStatus: one role="status"
// region with the hidden "טוען" / "Loading" label, pulse off under both motion
// switches).
//
// EAGER, NOT lazySkeleton. The Settings and Admin skeletons are code-split
// because ProtectedRoute warms them long before those pages are opened. These
// two routes are reached by a FULL page load - HYP redirects the browser here -
// so a code-split skeleton would always be cold and the body would stay empty
// while it downloaded. This module is a few MUI boxes on modules the shell
// already loads (Box/Skeleton, the brand Logo the navbar uses), so it rides in
// the main chunk at near-zero cost.
//
// Rendered inside PageBodySuspense, so it receives AuthLayout's `isHebrew`.

import React from "react";

import SkeletonStatus from "../loading/SkeletonStatus";
import { PaymentCard, PaymentFrame } from "./PaymentShell";
import {
  ActionsSkeleton,
  HelpLeadSkeleton,
  HeroSkeleton,
  NoticeSkeleton,
  ReceiptSkeleton,
  ReferenceSkeleton,
} from "./PaymentSkeletonParts";

// The shell and its aria-hidden shapes wrapper grow like the page's own frame
// (flex: 1 in AuthLayout's main column), so the card is centred at the same
// height from `sm` and the swap to the page does not jump.
const FILL_SX = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  "& > [aria-hidden='true']": { flex: 1, display: "flex", flexDirection: "column" },
};

/**
 * @param {object} p
 * @param {boolean} [p.isHebrew]  injected by PageBodySuspense
 * @param {'receipt'|'notice'} [p.variant='receipt']  success / failure body
 */
export default function PaymentPageSkeleton({ isHebrew, variant = "receipt" }) {
  const receipt = variant !== "notice";
  return (
    <SkeletonStatus isHebrew={isHebrew} testId="payment-page-skeleton" sx={FILL_SX}>
      <PaymentFrame isHebrew={isHebrew}>
        <PaymentCard state="skeleton" hero={<HeroSkeleton tagline={receipt} />}>
          {/* The resolved pages' block order (PaymentSkeletonParts.js). */}
          {receipt ? <ReceiptSkeleton /> : <NoticeSkeleton />}
          <ActionsSkeleton />
          {!receipt && <HelpLeadSkeleton />}
          <ReferenceSkeleton />
        </PaymentCard>
      </PaymentFrame>
    </SkeletonStatus>
  );
}
